



















import { Component, Mixins } from 'vue-property-decorator'

import FieldTitle from '../../components/FieldTitle.vue'
import Validation from '../../components/Validation.vue'
import { BaseInput } from '../../mixins'

@Component({
  components: {
    Validation,
    FieldTitle,
  },
})
export default class AgreementCheckboxInput extends Mixins(BaseInput) {
  get titleKey(): string {
    const prefix = this.settings.prefix || ''
    return `${ prefix }${ this.settings.key }`
  }
}
